import React, { useState } from 'react';
import api from '../api/axios';
import styles from './ChangePasswordModal.module.css';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ isOpen, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  // 드래그 중 실수로 모달이 닫히는 것을 방지하기 위한 상태
  const [isMouseDownOnOverlay, setIsMouseDownOnOverlay] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      alert('새 비밀번호가 일치하지 않습니다.');
      return;
    }

    setIsLoading(true);
    try {
      await api.post('/users/change-password', { currentPassword, newPassword });
      alert('비밀번호가 성공적으로 변경되었습니다.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      onClose();
    } catch (err: any) {
      console.error('Failed to change password', err);
      alert(err.response?.data?.message || '비밀번호 변경 실패');
    } finally {
      setIsLoading(false);
    }
  };

  // 배경 클릭 시 닫기 (드래그 고려)
  const handleOverlayMouseUp = (e: React.MouseEvent) => {
    if (isMouseDownOnOverlay && e.target === e.currentTarget) {
      onClose();
    }
    setIsMouseDownOnOverlay(false);
  };

  return (
    <div 
      className={styles.overlay} 
      onMouseDown={(e) => setIsMouseDownOnOverlay(e.target === e.currentTarget)}
      onMouseUp={handleOverlayMouseUp}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2>비밀번호 변경</h2>
        <form onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <label>현재 비밀번호</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              placeholder="현재 비밀번호 입력"
            />
          </div>
          <div className={styles.inputGroup}>
            <label>새 비밀번호</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              placeholder="새 비밀번호 입력"
            />
          </div>
          <div className={styles.inputGroup}>
            <label>새 비밀번호 확인</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              placeholder="비밀번호 재입력"
            />
          </div>
          <div className={styles.actions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose}>취소</button>
            <button type="submit" className={styles.submitBtn} disabled={isLoading}>
              {isLoading ? '변경 중...' : '변경하기'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
